'use strict';

// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import { ssoFiltreraDatatable } from 'v-components/ssoFiltreraDatatable';
import { ssoTogglaRaderIDatatable } from 'v-components/ssoTogglaRaderIDatatable';

import euiMermeny from 'v-components/euiMermeny';
import euiPopUpMeny from 'v-components/euiPopUpMeny';
import euiDialog from 'v-components/euiDialog';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(

// Övrigt:
import { ssoTooltips } from 'ssoTooltips';
import { ssoAvstamningDatatable } from 'datatables/ssoAvstamningDatatable';
import SetOrUpdateClassOnFirstAndLastNonHiddenChild from 'SetOrUpdateClassOnFirstAndLastNonHiddenChild';

import axios from 'axios';
import objectToFormData from 'object-to-formdata';

//import { hubConnection } from 'signalr-no-jquery';

//------------------------------------------------------------------------------------------------------------------------------

//// Använd dessa Vue plugins:
//Vue.use(ssoFiltreraDatatable);
//Vue.use(ssoTogglaRaderIDatatable);

window.ssoAllaSidor = window.ssoAllaSidor || {};	// För att undvika ESLint-varningar att den är odefinierad.
window.ssoCacheDump = window.ssoCacheDump || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Todo: Temp.. *kanske*!
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.performance = process.env.NODE_ENV !== 'production';	// Inspekterbart i web tools flik Performance.

//##############################################################################################################################

//console.group('Skapa Vue-appen');
//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	store,	// ssoStatestore

	// Lokalt registrerade komponenter
	components: {
		euiMermeny,
		euiPopUpMeny,
		euiDialog,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {

		// Ytterligare data finns i ssoStateStore!
	},

	computed: {
	},

	watch: {

	},

	methods: {


	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Dessa används för att styra funktionalitet i mixin "ssoAllaSidorMixin":
		// Defaultvärde sätts numera i mixinen: this.$_rullningsbaraElementQuerySelectorAll = '.-rullningsbar-auto, .-rullningsbar-overlay, .-rullningsbar-auto-persist, .-rullningsbar-overlay-persist';
		this.$_vuexNamespace = 'chat';
	},

	//created() 
	//{
	//	// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	//},

	//beforeMount()
	//{
	//	// Called right before the mounting begins: the render function is about to be called for the first time.
	//	// This hook is not called during server-side rendering.
	//	// Detta är hooken efter att Vues kompilering är klar. v-cloak är fortfarande kvar, men plockas bort strax efter denna körts.
	//	// Här är det inte lämpligt att förändra DOM, för den ersätts vid den stundande renderingen och då tappas ändringarna (är jag ganska säker på).
	//},

	mounted() {
		// Called after the instance has been mounted, where el is replaced by the newly created vm.$el. If the root instance is mounted to an in-document element, vm.$el will also be in-document when mounted is called.
		// Note that mounted does not guarantee that all child components have also been mounted. If you want to wait until the entire view has been rendered, you can use vm.$nextTick inside of mounted:
		// mounted() {
		//   this.$nextTick(function () {
		//     // Code that will run only after the
		//     // entire view has been rendered
		//   })
		// }
		// This hook is not called during server-side rendering.

		//console.log("component mounted hook");

		//// Initiera Signal-R
		//// se https://www.npmjs.com/package/signalr-no-jquery

		//const connection = hubConnection('~/signalr');
		//const hubProxy = connection.createHubProxy('chatHub');

		//// set up event listeners i.e. for incoming "message" event
		//hubProxy.on('message', function (message) {
		//	console.log(message);
		//});

		//// connect
		//connection.start({ jsonp: true })
		//	.done(function () { console.log('Now connected, connection ID=' + connection.id); })
		//	.fail(function () { console.log('Could not connect'); });

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//console.log("component mounted hook + nextTick");

			//// DOM not updated yet
			//Vue.nextTick(function () {
			//		// DOM updated
			//		//console.log("component mounted hook + nextTick (DOM not updated yet) + ytterligare en nextTick");
			//	}
			//	, this	// Vue.nextTick 'this' context.
			//);

		})
	},

	//beforeUpdate()
	//{
	//	// Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
	//	// This hook is not called during server-side rendering, because only the initial render is performed server-side.
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//},

	//updated()
	//{
	//	// Called after a data change causes the virtual DOM to be re-rendered and patched.
	//	// The component’s DOM will have been updated when this hook is called, so you can perform DOM-dependent operations here. However, in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead.
	//	// This hook is not called during server-side rendering.
	//	// Note that updated does not guarantee that all child components have also been re-rendered.
	//	// Denna hook körs även efter mounted!
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."

	//	// Flyttad till en watch, bl.a. för att inte dubbelanropas (fast man hade väl också kunnat ta bort den från mounted()??):
	//	//SetOrUpdateClassOnFirstAndLastNonHiddenChild('#_ss-tabellen_kropp tbody');

	//	this.$nextTick(function () {
	//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//		// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

	//		// Flyttad hit från mounted(), för annars sätts den inte om efter v-if="false" –> "true":
	//		// (Den nollas (undefined) i en watch.)
	//		this.burgarenEl = document.getElementById('mermeny-sida-burgare');
	//	});
	//},

	//activated()
	//{
	//	// Called when a *kept-alive* component is activated.
	//	// This hook is not called during server-side rendering.
	//},

	//deactivated()
	//{
	//	// Called when a *kept-alive* component is deactivated.
	//	// This hook is not called during server-side rendering.
	//},

	//beforeDestroy()
	//{
	//	// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
	//	// This hook is not called during server-side rendering.
	//},

	//destroyed()
	//{
	//	// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
	//	// This hook is not called during server-side rendering.
	//},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
//console.groupEnd('Skapa Vue-appen');

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
